import {Row} from "react-vcomponents";
import {EngineConfig_Variants} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_Variants.js";
import type {LiveSession} from "../../LiveSession.js";
import {EngineSessionComp, StatusUIObj} from "./EngineSessionComp.js";
import React from "react";

export class VariantsComp extends EngineSessionComp<EngineConfig_Variants> {
	constructor(session: LiveSession, config: EngineConfig_Variants) {
		super(session, config, s=>true, s=>s.IsLocal());
	}

	override GetStatusUI(): StatusUIObj {
		return {
			ui: <Row mt={5}>Variants... active variant: {this.s.coreData.variantName}</Row>,
			omitWrapper: true,
		};
	}
}